import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, setToken } from "../../lib/api";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.token);
      toast.success("Welcome back.");
      nav("/admin/blog");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#122A1E] text-[#F4F4F1] flex items-center justify-center p-6">
      <form
        onSubmit={submit}
        className="w-full max-w-md border-2 border-[#F4F4F1] bg-[#0C1D14] p-8 hard-shadow-orange"
        data-testid="admin-login-form"
      >
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 bg-[#FF5A00] flex items-center justify-center">
            <Lock size={18} />
          </div>
          <div>
            <div className="font-mono-accent text-[10px] uppercase text-[#FF5A00]">◆ Admin</div>
            <div className="font-display font-black uppercase tracking-tight text-xl">
              Dispatch Console
            </div>
          </div>
        </div>

        <label className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#F4F4F1]/70 mb-2 block">
          Email
        </label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full bg-[#122A1E] border-2 border-[#F4F4F1]/40 px-4 py-3 text-[#F4F4F1] focus:outline-none focus:border-[#FF5A00] mb-5"
          data-testid="admin-email"
          autoComplete="email"
        />

        <label className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#F4F4F1]/70 mb-2 block">
          Password
        </label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full bg-[#122A1E] border-2 border-[#F4F4F1]/40 px-4 py-3 text-[#F4F4F1] focus:outline-none focus:border-[#FF5A00] mb-7"
          data-testid="admin-password"
          autoComplete="current-password"
        />

        <button
          type="submit"
          disabled={submitting}
          className="w-full inline-flex items-center justify-center gap-2 bg-[#FF5A00] hover:bg-[#E04F00] disabled:opacity-60 text-white font-display font-bold uppercase text-sm tracking-wider px-6 py-3 border-2 border-[#F4F4F1]"
          data-testid="admin-login-submit"
        >
          {submitting ? <Loader2 size={16} className="animate-spin" /> : null}
          {submitting ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
